var map = {
	"./en_ca.png": "454a",
	"./en_en.png": "a651",
	"./en_us.png": "ff49",
	"./es_spa.png": "b6ba",
	"./fr_fr.png": "04f0",
	"./id_ind.png": "47cd",
	"./ja_jp.png": "6cbe",
	"./ko_kr.png": "9d3a",
	"./ms_my.png": "c43b",
	"./pt_br.png": "1c70",
	"./ru_ru.png": "f6c6",
	"./th_th.png": "5c55",
	"./tr_tr.png": "0599",
	"./vi_vn.png": "18b4",
	"./zh_cn.png": "33ce",
	"./zh_hk.png": "4f25",
	"./zh_hk2.png": "9e0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f492";